import React from 'react';
import { styles } from './CartItemChangeAlert.css';
import { JBAlert } from '@jbhi-fi/lanyard-ui';
import { Link } from '../../PlatformFunctionality/Link';

export type CartItemChangeAlertProps = {
  isCartPage: boolean;
  currentSellerName?: string;
  currentSellerHref?: string;
  priceVariant?: 'increase' | 'decrease';
  variant: 'seller' | 'price';
  handleOnDismiss: () => void;
};

const getChangedAlertContent = (
  variant: 'seller' | 'price',
  priceVariant: 'increase' | 'decrease' | undefined,
  currentSellerName: string | undefined,
  currentSellerHref: string | undefined
) => {
  const sellerMessages = {
    increase:
      'Just a heads up that the seller and price has changed for this item as the previous selection is no longer available. It will now come from ',
    default: 'Just a heads up that this item will now come from ',
  };

  const priceMessages = {
    increase: 'Just a heads up that the price for this item has changed.',
    decrease: 'Price dropped since your last visit.',
  };
  const hasPriceIncreased = priceVariant === 'increase';
  const type = hasPriceIncreased ? 'info' : 'success';

  if (variant === 'seller') {
    const messagePrefix = hasPriceIncreased ? sellerMessages.increase : sellerMessages.default;
    const messageSuffix = hasPriceIncreased ? '.' : ' as your previous selection is no longer available.';
    return {
      heading: 'Marketplace item updated',
      type: 'info',
      content: (
        <React.Fragment>
          {messagePrefix}
          <wbr />
          {React.createElement(
            currentSellerHref ? Link : 'span',
            { className: styles.sellerName, href: currentSellerHref as string },
            currentSellerName
          )}
          <wbr />
          {messageSuffix}
        </React.Fragment>
      ),
    };
  }

  return {
    heading: `Price ${hasPriceIncreased ? 'increase' : 'dropped!'}`,
    type,
    content: priceMessages[priceVariant || 'increase'],
  };
};

export const CartItemChangeAlert = ({
  isCartPage,
  currentSellerName,
  currentSellerHref,
  priceVariant,
  variant,
  handleOnDismiss,
}: CartItemChangeAlertProps) => {
  const {
    heading,
    content,
    type = 'info',
  } = getChangedAlertContent(variant, priceVariant, currentSellerName, currentSellerHref);

  return (
    <JBAlert
      type={type as 'info' | 'success'}
      heading={heading}
      closable
      onDismiss={handleOnDismiss}
      classes={styles.container({ isCartPage })}
      content={content}
    ></JBAlert>
  );
};
